import { render, staticRenderFns } from "./Stamp.vue?vue&type=template&id=565054c0&scoped=true&"
import script from "./Stamp.vue?vue&type=script&lang=js&"
export * from "./Stamp.vue?vue&type=script&lang=js&"
import style0 from "./Stamp.vue?vue&type=style&index=0&id=565054c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565054c0",
  null
  
)

export default component.exports